import React from 'react';

export const Content = ({ children }) => (
  <div className="cart-popup__content">
    {children}
  </div>
);
